
import { Button, Paper } from '@mui/material';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import NavBarAdm from './navbarAdm';

export const QRCode = () => {
    const [qrText, setQrText] = useState('');
    const [overlayText, setOverlayText] = useState('');
    const [qrImageSrc, setQrImageSrc] = useState('');
    const [showImage, setShowImage] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleGenerate = () => {
        if (qrText.length > 0) {
            const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrText)}`;
            setQrImageSrc(qrSrc);
            setShowImage(true);
            console.log(qrText);
        } else {
            setHasError(true);
            setTimeout(() => {
                setHasError(false);
            }, 1000);
        }
    };

    const handleDownload = async () => {
        if (qrImageSrc) {
            try {
                const res = await fetch(qrImageSrc);
                const blob = await res.blob();

                // Create a canvas to combine QR code and text
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                // Create an image element to load the QR code
                const img = new Image();
                img.crossOrigin = 'anonymous';

                img.onload = () => {
                    // Set canvas size (QR code height + extra space for text)
                    const padding = 60;
                    canvas.width = Math.max(img.width, 300);
                    canvas.height = img.height + (overlayText ? padding : 0);

                    // Fill white background
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    // Draw QR code centered
                    const x = (canvas.width - img.width) / 2;
                    ctx.drawImage(img, x, 0);

                    // Draw overlay text if provided
                    if (overlayText) {
                        ctx.fillStyle = 'rgba(0, 0, 0, 0.8)';
                        ctx.font = 'bold 32px Arial';

                        // Measure text width
                        const textMetrics = ctx.measureText(overlayText);
                        const textWidth = textMetrics.width;
                        const textHeight = 40;

                        // Create text background - positioned properly within canvas
                        const textX = (canvas.width - textWidth) / 2 - 8;
                        const textY = img.height + 10;
                        ctx.fillRect(textX, textY, textWidth + 16, textHeight + 8);

                        // Draw text - positioned properly within canvas
                        ctx.fillStyle = 'white';
                        ctx.textAlign = 'center';
                        ctx.fillText(overlayText, canvas.width / 2, textY + textHeight - 2);
                    }

                    // Convert canvas to blob and download
                    canvas.toBlob((blob) => {
                        const downloadLink = document.createElement("a");
                        downloadLink.href = URL.createObjectURL(blob);
                        downloadLink.download = "qrCode.jpg";
                        downloadLink.click();
                    }, 'image/jpeg', 0.9);
                };

                img.src = URL.createObjectURL(blob);

            } catch (error) {
                console.error('Error downloading QR code:', error);
            }
        }
    };

    return (
        <>
        <NavBarAdm />
        
            <Card sx={{ maxWidth: 600, padding: '1rem', margin: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>                
                    <h2>QR - Code</h2><p style={{fontSize: 9, color: 'lightgray'}}>vers. 1.2</p>
                </div>

                <Paper elevation={0}>
                    <p>Text oder URL</p>
                    <TextField
                        type="text"
                        placeholder="Text or URL"
                        value={qrText}
                        onChange={(e) => setQrText(e.target.value)}
                        error={hasError}
                        multiline
                        rows={3}
                        fullWidth
                        variant="outlined"
                        sx={{ marginBottom: '10px' }}
                    />

                    <TextField
                        type="text"
                        placeholder="Overlay text (optional)"
                        value={overlayText}
                        onChange={(e) => setOverlayText(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ marginBottom: '10px' }}
                    />
                </Paper>


                <Paper elevation={0} sx={{ mb: overlayText ? '60px' : '20px', textAlign: 'center' }}>
                    {showImage && (
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <img
                                src={qrImageSrc}
                                alt="QR Code"
                                style={{
                                    maxWidth: '200px',
                                    height: 'auto',
                                    border: '1px solid #ccc'
                                }}
                            />
                            {overlayText && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        bottom: '-50px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                        color: 'white',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontSize: '40px',
                                        fontWeight: 'bold',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '200px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis'
                                    }}
                                >
                                    {overlayText}
                                </div>
                            )}
                        </div>
                    )}
                </Paper>

                <Paper elevation={0} >
                    <Button
                        onClick={handleGenerate}                        
                        variant="contained"
                        sx={{ marginRight: '10px' }}
                        color="primary"
                        >
                        Generate
                    </Button>
                    <Button
                        onClick={handleDownload}
                        disabled={!showImage}
                        variant="contained"
                        color="secondary"
                        sx={{ marginRight: '10px' }}

                    >
                        Download
                    </Button>
                </Paper>
            </Card >
        </>
    );
};
